// src/features/dashboard/teacher/AttendanceCellEditor.jsx
import React, { useState, useEffect } from 'react';
import Modal from '../../../components/ui/Modal';

const STATUSES = ['Present', 'Absent', 'Arrive Late', 'Leave Early', 'Late & Early', 'No Class'];

const AttendanceCellEditor = ({ isOpen, onClose, student, date, currentStatus, currentActivity, topicOptions, onSave }) => {
  const [status, setStatus] = useState(currentStatus || 'Present');
  const [activity, setActivity] = useState(currentActivity || '');

  useEffect(() => {
    if (isOpen && student) {
      setStatus(currentStatus || 'Present');
      setActivity(currentActivity || '');
    }
  }, [isOpen, student, currentStatus, currentActivity]);

  if (!student) return null;

  const handleSave = () => {
    onSave(status, activity);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <h4 className="text-lg font-bold mb-2">
        {student.name} {student.surname} – {new Date(date).toLocaleDateString()}
      </h4>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium">Status</label>
          <div className="flex flex-wrap gap-2 mt-1">
            {STATUSES.map(s => (
              <label key={s} className="flex items-center gap-1">
                <input
                  type="radio"
                  name="status"
                  value={s}
                  checked={status === s}
                  onChange={() => setStatus(s)}
                />
                {s}
              </label>
            ))}
          </div>
        </div>

        {/* Topic dropdown */}
        <div>
          <label className="block text-sm font-medium">Topic</label>
          <input
            type="text"
            list="topic-options"
            value={activity}
            onChange={e => setActivity(e.target.value)}
            placeholder="Search or select a topic"
            className="w-full border rounded px-2 py-1"
          />
          <datalist id="topic-options">
            {topicOptions && topicOptions.map((opt, idx) => (
              <option key={idx} value={opt.value} />
            ))}
          </datalist>
        </div>

        {/* Optional notes */}
        <div>
          <label className="block text-sm font-medium">Additional Notes</label>
          <input
            type="text"
            value={activity}
            onChange={e => setActivity(e.target.value)}
            placeholder="Optional notes"
            className="w-full border rounded px-2 py-1"
          />
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <button onClick={onClose} className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400">
            Cancel
          </button>
          <button onClick={handleSave} className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700">
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AttendanceCellEditor;